var _rect, _rect2, _rect3, _g, _g2, _g3, _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetireChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5903:8521)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1336,
    height: 6492,
    transform: "translate(-916 -200)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5903:8521",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -916,
    y: -134,
    width: 1336,
    height: 764
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -916,
    y: -134,
    width: 1336,
    height: 764,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5903:8521)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.889 207.567V-118.319H-1096.5V209.649C-1182.24 244.544 -1231.08 284.74 -1231.08 327.525C-1231.08 461.441 -752.536 570.002 -162.22 570.002C428.097 570.002 906.643 461.441 906.643 327.525C906.643 283.887 855.828 242.941 766.889 207.567Z",
    fill: "url(#paint0_linear_5903:8521)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M697.326 180.888V-145.002H-1166.07V182.97C-1251.8 217.866 -1300.64 258.062 -1300.64 300.847C-1300.64 434.763 -822.099 543.324 -231.782 543.324C358.534 543.324 837.08 434.763 837.08 300.847C837.08 257.209 786.265 216.263 697.326 180.888Z",
    fill: "url(#paint1_linear_5903:8521)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5903:8521)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -184,
    y: -76,
    width: 449,
    height: 617,
    rx: 24,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -183.5,
    y: -75.5,
    width: 448,
    height: 616,
    rx: 23.5,
    stroke: "#F8ECE4",
    strokeOpacity: 0.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5903:8521)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: -8,
    width: 94,
    height: 33,
    rx: 5,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -6.5,
    y: -7.5,
    width: 93,
    height: 32,
    rx: 4.5,
    stroke: "#A33635"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#FFEBDD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#A33635"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.138 10.5287L3.94267 8.33333L3 9.276L6.138 12.414L12.6093 5.94267L11.6667 5L6.138 10.5287Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5903:8521",
    x: -209,
    y: -97,
    width: 499,
    height: 667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5903:8521"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5903:8521",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5903:8521",
    x: -15,
    y: -16,
    width: 118,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5903:8521"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5903:8521",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5903:8521",
    x1: -2778.86,
    y1: 1366.82,
    x2: 67.7525,
    y2: -1083.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A33635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E0C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5903:8521",
    x1: -2848.42,
    y1: 1340.15,
    x2: -1.79391,
    y2: -1109.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A33635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E0C0C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5903:8521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1336,
    height: 6492,
    fill: "white",
    transform: "translate(-916 -200)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetireChecked);
export default __webpack_public_path__ + "static/media/Retire_Checked.8f7df4d0f2dd796256e1d9c761c69f72.svg";
export { ForwardRef as ReactComponent };